import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'

const root = ReactDOM.createRoot(document.getElementById('root'));
document.title = 'Cooptraiss'

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path='/cooptraiss' element={<App />} />
        <Route path='/sms/*' element={<App />} />
        <Route path='*' element={<Navigate to='/cooptraiss'/>} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
